import { BasicMoreSettings } from './BasicMoreSettings'

export const LinkMoreSettings = entry => {
  return <BasicMoreSettings placeValueIn={false} {...entry} />
}
